import React from "react";

import Slider from "react-slick";
import { HeaderConfig, appliedConfig } from "../config/commonConfig";

const Depoimentos = () => {
  
  const videos = [
    {
      name: 'Depoimento 1',
      src: 'https://player.vimeo.com/video/1127177960?badge=1&amp;autopause=0&amp;autoplay=0&amp;player_id=1&amp;app_id=58479'
    },
    {
      name: 'Depoimento 2',
      src: 'https://player.vimeo.com/video/1127179059?badge=1&amp;autopause=0&amp;autoplay=0&amp;player_id=2&amp;app_id=58479'
    },
    {
      name: 'Depoimento 3',
      src: 'https://player.vimeo.com/video/1127178767?badge=1&amp;autopause=0&amp;autoplay=0&amp;player_id=3&amp;app_id=58479'
    },
    {
      name: 'Depoimento 4',
      src: 'https://player.vimeo.com/video/1127177550?badge=1&amp;autopause=0&amp;autoplay=0&amp;player_id=4&amp;app_id=58479'
    },
    {
      name: 'Depoimento 5',
      src: 'https://player.vimeo.com/video/1143979176?badge=1&amp;autopause=0&amp;autoplay=0&amp;player_id=5&amp;app_id=58479'
    }
  ]

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-prev slick-arrow" + (currentSlide === 0 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-left"></i>
    </button>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-next slick-arrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-right"></i>
    </button>
  );

  var settings = {
    dots: true,
    arrows: true,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4500,
    slidesToShow: 4,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  return (
    <section
      id="depoimentos"
      className={
        "section " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : " ")
      }
    >
      <div className="container">
        <h2 className="text-9 fw-600 text-center">Depoimentos dos nossos parceiros</h2>
        <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
        <p className="lead text-center mb-4">
          Parceria boa gera lucro e satisfação para todos!
        </p>
        <Slider {...settings}>
          {videos.length > 0 &&
            videos.map((video, index) => (
              <div
                className="item depoimento border rounded text-center p-4"
                key={index}
              >
                <span className="text-9 text-body-tertiary opacity-2">
                  <i className="fa fa-quote-left" />
                </span>
                <div className="player ratio ratio-3x4">
                    <iframe
                      src={video.src}
                      title={video.name}
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowfullscreen
                    ></iframe>
                    <br clear="all" />
                  </div>
                {" "}
              </div>
            ))}
        </Slider>
      </div>
    </section>
  );
};

export default Depoimentos;
